module.exports = __webpack_public_path__ + "img/qrCode.653e1710.png";